import React from 'react';
import OwlCarousel from 'react-owl-carousel';  
import { Link } from 'react-router-dom';
export default function PortfoliFive(){
    return(
        <section class="portfolio-area pt-120 pb-150 pt-md-80 pb-md-80 pb-xs-60 pt-xs-0 home-5">
			<div class="container">
				<div class="row">
					<div class="col-lg-8">
						<div class="portfolio-section-title2">
							<h6 class="semi-title">Our Completed Work</h6>
							<h2 class="sect-title">Latest Projects</h2>
						</div>
					</div>
				</div>

                <OwlCarousel items={3}  
                className="owl-theme portfolio-slide2"  
                loop 
                dots={false}			  
                margin={30}
				responsive= {
					{
						'1':{
							items: 1
						},
						'768': {
							items: 2
						},
	
						'1200': {
							items: 3
						}
	
					}
					
				} >
					
				
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/3-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">Ninja Smart Vision</h4>
									<span>IT Solution / UI &amp; UX</span>
								</div>
								<Link class="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                   
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/4-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">Smartix Web Solution</h4>
									<span>IT Solution</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/5-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">Smartic Pro Solution</h4>
									<span>IT Solution</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/2-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">RT Pro Technology</h4>
									<span>UI &amp; UX</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/3-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">Ninja Smart Vision</h4>
									<span>IT Solution / UI &amp; UX</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/4-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">Smartix Web Solution</h4>
									<span>IT Solution</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/5-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">Smartic Pro Solution</h4>
									<span>IT Solution</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/2-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">RT Pro Technology</h4>
									<span>UI &amp; UX</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/3-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">Ninja Smart Vision</h4>
									<span>IT Solution / UI &amp; UX</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    <div class="item">
						<div class="portfolio-wrapper5">
							<img class="img-fluid" src="assets/img/home-5/4-520x350.jpg" alt="Portfolio Img" />
							<div class="single-portfolio d-flex">
								<div class="text">
									<h4 class="portfolio-title">Smartix Web Solution</h4>
									<span>IT Solution</span>
								</div>
								<Link className="pf-btn2" to="/case-details"><i class="fal fa-long-arrow-right"></i></Link>
							</div>
						</div>
					</div>
                    </OwlCarousel>       

          
                    
			</div>
		</section>
    )
}